const messageActionTypes = {
  CHATSELECTED: "CHATSELECTED",
  CLOSECHAT: "CLOSECHAT",
  ADDMESSAGE: "ADDMESSAGE",
  OPENMODAL: "OPENMODAL",
  CLOSEMODAL: "CLOSEMODAL",
  SETCHATSOURCE: "SETCHATSOURCE",
  SETCHATS: "SETCHATS",
  ADDUSERTOCHATS: "ADDUSERTOCHATS",
};

export default messageActionTypes;
